<template>
  <div class="box__wrap">
    <router-link
      :to="{ name: 'description', params: { slug: slug, title: title } }"
    >
      <div class="box">
        <div class="box__content">
          <iconBase :gradientOn="false">
            <component :is="getImage"></component>
          </iconBase>
          <h2 class="box__title">{{ title }}</h2>
          <div class="box__link">
            <svg
              class="box__link-dot"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
            >
              <circle cx="10" cy="10" r="10" fill="#f7902d" />
            </svg>
            <div class="box__link-arrow">
              <div class="arrow__body"></div>
              <svg
                class="arrow__head"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5.99 6"
              >
                <path
                  d="M0 6V0l5.99 2.89V3L0 6z"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  fill="#fff"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import S from "string";
import iconBase from "./icons/iconBase";
import iconFamily from "./icons/iconFamily";
import iconJob from "./icons/iconJob";
import iconEducation from "./icons/iconEducation";
import iconHealth from "./icons/iconHealth";
import iconSecurity from "./icons/iconSecurity";
import iconDiplomacy from "./icons/iconDiplomacy";
export default {
  components: {
    iconBase,
    iconFamily,
    iconJob,
    iconEducation,
    iconHealth,
    iconSecurity,
    iconDiplomacy,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    }
  },
  computed: {
    getImage() {
      return this.icon;
    },
    slug() {
      return S(this.title).slugify().s;
    }
  }
};
</script>

<style lang="scss" scoped>
.box__wrap {
  margin: 10px;
}

.box {
  border: 2px solid #f7902d;
  border-radius: 5px;
  display: inline-block;
  position: relative;
  text-align: center;
  width: 348px;
  height: 340px;
  background-image: url(/assets/images/jpg/box-bg.jpg);
  background-size: cover;
  background-position: 100% 100%;
  overflow: hidden;
  &::after {
    content: "";
    position: absolute;
    bottom: -45px;
    left: -10%;
    width: 120%;
    height: 80%;
    background-color: #101d5d;
    background-image: linear-gradient(
      -15deg,
      rgb(0, 10, 56) 30%,
      rgba(0, 10, 56, 0) 70%
    );
    transform: skew(0deg, 15deg) translateY(0px);
    z-index: 0;
    transition: background-color 0.3s ease, background-image 0.3s ease,
      transform 0.3s ease, height 0.3s ease;
  }

  &:hover {
    &::after {
      background-color: #f7902d;
      background-image: linear-gradient(
        15deg,
        rgb(219, 107, 0) 30%,
        rgba(219, 107, 0, 0) 70%
      );
      transform: skew(0deg, -15deg) translateY(0px);
      height: 85%;
    }

    .box__link-dot {
      circle {
        fill: #063e89;
      }
    }

    .arrow__body {
      width: 48px;
    }
  }
}

.box__content {
  padding: 30px 40px;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.box__title {
  font-size: 36px;
  font-family: "Anton", sans-serif;
  font-weight: normal;
  color: #fff;
  text-align: left;
  margin: 0;
  text-transform: uppercase;
  line-height: 1.2;
  margin-top: 15px;
}

.box__link {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.box__link-dot {
  circle {
    transition: fill 0.3s ease;
  }
}

.box__link-arrow {
  display: flex;
  align-items: center;
  margin-left: -10px;
}

.arrow__body {
  width: 28px;
  height: 2px;
  background-color: #fff;
  transition: width 0.3s ease;
}

.arrow__head {
  width: 6px;
  height: 6px;
}

.box__content {
  > svg {
    height: 125px;
    overflow: visible;
  }
}

@media screen and (min-width: 480px) {
}

@media screen and (min-width: 970px) {
  .box__content {
    padding: 30px 40px;
  }
}

@media screen and (min-width: 1170px) {
  .box {
    width: 277px;
    height: 274px;
  }

  .box__content {
    padding: 20px 30px;
    > svg {
      height: 100px;
    }
  }

  .box__title {
    font-size: 30px;
    margin-top: 10px;
  }
}

@media screen and (min-width: 1452px) {
  .box {
    width: 348px;
    height: 340px;
  }

  .box__content {
    > svg {
      height: 125px;
    }
  }

  .box__title {
    font-size: 36px;
    margin-top: 15px;
  }
}
</style>
